<script setup lang="ts">
import HomeLiveItem from "@/home/components/HomeLiveItem.vue";
import {HomePatientUserItem} from "@/home/interfaces";
import {useRouter} from "vue-router";
import {useLiveStore} from "@/stores/live.store";
import {LiveItemType} from "@/core/interfaces/live/LiveItem";

const {item} = defineProps<{
    item: HomePatientUserItem['data'],
}>();
const router = useRouter();
const {updateItem} = useLiveStore();

const onItemPress = () => {
    if (item?.id) {
        updateItem(item.id, LiveItemType.PATIENT_USER)
            .then(() => router.push({
                name: 'patient-administration.application.pending-customers',
                query: {first_name: item.first_name, last_name: item.last_name}
            }));
    } else {
        router.push({name: 'patient-administration.application.pending-customers'});
    }
};
</script>

<template>
  <HomeLiveItem
    :at="item?.created_at ?? 'Date non disponible'"
    @click="onItemPress"
  >
    <template #image>
      <div class="w-full">
        <img
          alt="Survey"
          width="100%"
          src="@/assets/icons/patient-app-request.svg"
          class="w-[90%] object-contain primary"
        >
      </div>
    </template>
    <p class="font-semibold">
      {{ item.first_name }} {{ item.last_name }}
    </p>
    <p>Demande d’accès Application Apodis</p>
  </HomeLiveItem>
</template>
